module.exports = __webpack_public_path__ + "media/images/build-your-team_empty-f28787fd.svg";